import { AuthProvider } from '@griply/types';

import { getAuthProvider } from './get-auth-provider';

export type SignInProviderInfo = { providerId: string };

// A password wins: only an account that has one can change its email or password in the app.
export const getSignInProvider = (
  providerData: readonly SignInProviderInfo[],
): AuthProvider | null => {
  const providers = providerData.map(({ providerId }) =>
    getAuthProvider(providerId),
  );
  if (providers.includes(AuthProvider.Email)) {
    return AuthProvider.Email;
  }
  return providers.find((provider) => provider !== null) ?? null;
};
